import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { CheckoutFormsStoreModule } from '../../../../core/checkout/checkout-forms-store.module';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { CheckoutOrderReviewComponent } from './checkout-order-review.component';

@NgModule({
  imports: [CommonModule, I18nModule, DynamicFormsModule, CheckoutFormsStoreModule, CheckoutOrderReviewComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutOrderReview: {
          component: CheckoutOrderReviewComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [CheckoutOrderReviewComponent],
})
export class CheckoutOrderReviewModule {}
